import { 
    getItem,
    getConstraint,
    pushNew,
 } from "./debriefingUtils"

import { hasSubPhases } from "./actionInsertion"
import { aggregateLabels } from "@meddbriefer/feedback-data"


//start support functions for constraint checking

const findNameNumID = (names, entries, item, occurrence) => {
    let result = undefined
    let index = undefined
    for (let i = 0; i < names.length; i++) {
        if (item.id === names[i]) {
            result = entries[i]
            if (occurrence === "start") {
                break}}}
    if (!!result) {
        if (result.numericalID === -1) {
            if (occurrence === "start") {
                index = result.numericalIDStart}
            else { index = result.numericalIDEnd }}
        else { index = result.numericalID }}

    return index
}





const findObjByNumerialID = (numericalID,phases,phaseNames, checklistHierarchy) => {
    for (let phaseIndex = 0; phaseIndex < phaseNames.length; phaseIndex++) {
        let phaseObjects = phases[phaseIndex];
        let phaseName = phaseNames[phaseIndex];
        if (phaseObjects.length > 0 && !hasSubPhases(phaseName, checklistHierarchy)){
            for (let entry of phaseObjects){
                if (entry.numericalID === numericalID){
                    return [entry, phaseName]}
            }}}}






const storeMisOrderedFB = (numericalID, lateArg, otherArg, FB, constraintType, phases, phaseNames, checklistHierarchy, phaseFB) => {
    let result = findObjByNumerialID(numericalID, phases, phaseNames, checklistHierarchy,)
    let objToModify = result[0]
    if (constraintType === "item"){
        if (!objToModify) {console.log("no object found for numericalID = ", numericalID)}  //just for debugging
        else {
            if (objToModify.orderingFB !== "") {
                objToModify.orderingFB = objToModify.orderingFB + "\xa0\xa0" + FB}
            else { objToModify.orderingFB = FB }
        let status
        let appendString = "misOrdered-"
        if (!(objToModify.status.includes(appendString)))
                {status = appendString + objToModify.status
                objToModify.status = status}}}
    else {
        if (!!phaseFB[lateArg]){
            phaseFB[lateArg].arg2 = phaseFB[lateArg].arg2.concat([otherArg])
            phaseFB[lateArg].feedback = phaseFB[lateArg].feedback + ".  " + FB}
        else {
            phaseFB[lateArg] = {}
            phaseFB[lateArg].arg2 = [otherArg]
            phaseFB[lateArg].feedback = FB}
    }

}


//flattens out the phases and phaseNames data structures so that all phase and subphase
//names have their own entry and each item under a phase or subphase has its own entry.
//Collect and return unique names because phase and subphase names can appear multiple times in the
//phases and phaseNames ds.  Having a unique list of names means that a constraint will only be checked once.


const collectEntriesToCheckConstraints = (phases, phaseNames,requiredPhaseNames,requiredSubphases,checklistHierarchy) => {
    let listOfNames = []
    let listOfEntries = []
    let uniqueListOfNames = []
    let counter = -1
    for (let phaseIndex = 0; phaseIndex < phaseNames.length; phaseIndex++) {
        let phaseObjects = phases[phaseIndex];
        let phaseName = phaseNames[phaseIndex];
        //filter out "not indicated" entries
        phaseObjects = phaseObjects.filter(o => !!o.status && o.status !== "not indicated")
        let startIndex = phaseObjects[0].numericalID
        let endIndex = phaseObjects[phaseObjects.length-1].numericalID

        //handle phases and subphases first

        if (requiredPhaseNames.includes(phaseName) || requiredSubphases.includes(phaseName)) {
            listOfEntries.push({ id: phaseName, numericalID: counter, numericalIDStart: startIndex, numericalIDEnd: endIndex })
            listOfNames.push(phaseName)
            if (!uniqueListOfNames.includes(phaseName)){uniqueListOfNames.push(phaseName)}}

        //can't be an else to above because a phase can have entries but a subphase cannot

        if (phaseObjects.length > 0 && !hasSubPhases(phaseName, checklistHierarchy)){
            let phaseObjectNames = phaseObjects.map(obj => obj.id)
            phaseObjectNames.forEach(entry => {
                pushNew(entry,uniqueListOfNames)
            })
            listOfEntries = listOfEntries.concat(phaseObjects)
            //uniqueListOfNames = uniqueListOfNames.concat(phaseObjectNames)
            listOfNames = listOfNames.concat(phaseObjectNames)
        }
    }
return [listOfNames, uniqueListOfNames, listOfEntries]

}

const saveFailedConstraint = (lateArg, lateNum, otherArg, constraintID, constraintsViolated) => {
    let type
    if (["phase", "sub-phase"].includes(lateArg.type)){
        type = "phase"}
    else {type = "item"}
    constraintsViolated.push({constraintID: constraintID, arg1: lateArg.id, arg1Num: lateNum, op: "before", arg2: otherArg.id, type: type})
    return type
}


const checkAgainst2ndArgs = (arg1st, args2nd, op, constraintID, entryNames, entries, itemByID, itemByLabel, constraintsViolated) => {
    let endNum1st = findNameNumID(entryNames, entries, arg1st, "end")
    let startNum1st = findNameNumID(entryNames, entries, arg1st, "start")
    if (!["phase", "sub-phase"].includes(arg1st.type) && startNum1st !== endNum1st) {
        //means have duplicate entries for a single item
        //so use the earliest entry only to test before
        endNum1st = startNum1st
    }
    if (args2nd.length > 0) {
        for (let arg of args2nd) {
            let arg2nd = getItem(arg, itemByID, itemByLabel)
            if (!!arg2nd) {
                let startNum2nd = findNameNumID(entryNames, entries, arg2nd, "start")
                if (!!endNum1st && !!startNum2nd) {
                    if (!(endNum1st < startNum2nd)) {  //if failed constraint i.e. arg1 is late
                        saveFailedConstraint(arg1st, startNum1st, arg2nd, constraintID, constraintsViolated)           
                    }
                    else {
                        if (op === "or") {
                            return
                        }}
                }
            }
        }
    }
}

const generateConstraintFB = (constraints, itemByID, itemByLabel, phases, phaseNames, checklistHierarchy, phaseFB) => {
    for (const [, entry] of Object.entries(constraints) ){
        let FB = ""
        let orig1stLabel = ""
        const {arg1: arg1st, arg1Num, type: cType, arg2: args2} = entry
        let arg1stItem = getItem(arg1st, itemByID, itemByLabel)
        let label1st 
        if (!!arg1stItem){
            orig1stLabel = arg1stItem.label
            label1st = arg1stItem.label}
        else {label1st = arg1st}
        label1st = label1st[0].toLowerCase() +  label1st.substring(1)
        if (cType === "phase"){
            FB = "You should have completed the " + label1st 
        }
        else {
            FB = "You should have " + label1st 
        }
        //turn arg2s into labels
        let part2 = ""
        let arg2Labels = ""
        for (let i = 0; i < args2.length; i++){
            let argItem = getItem(args2[i], itemByID, itemByLabel)
            let label2nd 
            if (!!argItem){
                label2nd = argItem.label
            }
            else {label2nd = args2[i]}
            label2nd = label2nd[0].toLowerCase() + label2nd.substring(1)
            if (args2.length > 1){
                if (i === 0){  //first item in list
                    part2 = " before you started " + label2nd
                    arg2Labels = label2nd
                }
                if (i+1 === args2.length){  //last item in list
                    part2 = part2 + ", and " + label2nd
                    arg2Labels = arg2Labels + " and " + label2nd
                }
            }
            else {//only item in the list
                part2 = " before you did " + label2nd
                arg2Labels = label2nd
            } 
        }
        FB = FB + part2 + "."
        storeMisOrderedFB(arg1Num, orig1stLabel, arg2Labels, FB, cType, phases, phaseNames, checklistHierarchy, phaseFB)
    }
}

const findAggregateLabel = (item) => {
    for (const [label, arr] of Object.entries(aggregateLabels)) {
        if (arr.includes(item)){
            return(label)
        }
    }
    return undefined
}

const aggregateArguments = (constraintsViolated) => {
//first collect together all the args that late items/phases are late with respect to, in order
//to aggregate when possible the list of items in the feedback
 let lateArgEntries = {}
 for (const [,instance] of Object.entries(constraintsViolated))  {
    const {arg1: lateArg, arg1Num: lateNum, type, arg2} = instance
    let key = lateArg + "-" + type
    let currentObj = lateArgEntries[key]
    if (!!currentObj){
        currentObj.arg2 = (currentObj.arg2).concat(arg2)     
    }
    else {
        currentObj = {arg1: lateArg, arg1Num: lateNum, arg2: [arg2], type: type}
    } 
    lateArgEntries[key] = currentObj
  }

  //now replace the arg2s that can be replaced by an aggregate label
  for (const [lateArg, entry] of Object.entries(lateArgEntries)) {
    let arg2s = entry.arg2
    let newArgs = JSON.parse(JSON.stringify(arg2s))  //make a deep copy
    for( var i = 0; i < arg2s.length; i++){ 
        let aggregateLabel = findAggregateLabel(arg2s[i])
        let index = newArgs.findIndex(e => e === arg2s[i])
        if (!!aggregateLabel){
            newArgs.splice(index, 1); //remove the item
            if (!newArgs.includes(aggregateLabel)){
                newArgs = newArgs.concat(aggregateLabel)
            }
        } 
    }
    entry.arg2 = newArgs
    lateArgEntries[lateArg] = entry
    
  }
  return lateArgEntries
}

const checkConstraintsForArg = (arg1st, constraint, entryNames, entries,itemByID,itemByLabel,constraintsViolated) => {
    let op
    let args2nd = (constraint.before).filter(l => entryNames.includes(l))
    if (args2nd.length > 0){
        op = constraint.beforeOp
        checkAgainst2ndArgs(arg1st,args2nd,op,constraint.id,entryNames,entries,itemByID,itemByLabel,constraintsViolated)
    }
}

  //end support functions for constraint checking



//To DO Future: filter constraints in/out based on findings available for this scenario

//main function for constraint checking
export const checkAgainstKB = (phases, phaseNames,requiredPhaseNames,requiredSubphases,checklistHierarchy,itemByID,itemByLabel,constraintsViolated,phaseFB) => {

    let result = collectEntriesToCheckConstraints(phases, phaseNames, requiredPhaseNames, requiredSubphases, checklistHierarchy)
    let entryNames = result[0]
    let uniqueEntryNames = result[1]
    let entries = result[2]
    uniqueEntryNames.forEach(firstArg => {
        let firstArgItem = getItem(firstArg,itemByID,itemByLabel)
        if (!!firstArgItem) {
            processFirstArg(firstArgItem,entryNames,entries,itemByID,itemByLabel,constraintsViolated)}})

    let aggregatedConstraints = aggregateArguments(constraintsViolated)
    generateConstraintFB(aggregatedConstraints, itemByID, itemByLabel, phases, phaseNames, checklistHierarchy, phaseFB)
    //only expect to change objects in phases
    return [phases, phaseNames]
}

const processFirstArg = (firstArgItem, entryNames, entries,itemByID,itemByLabel,constraintsViolated) => {
    let constraint = getConstraint(firstArgItem)  //will find only one constraint per 1st arg
    if (!!constraint) {
        checkConstraintsForArg(firstArgItem, constraint, entryNames, entries,itemByID,itemByLabel,constraintsViolated)}
}
